import * as Yup from 'yup';

export const resetPasswordValidate = Yup.object().shape({
  newPassword: Yup.string()      
    .matches(/^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[A-Z])(?=.*[0-9]).+$/, 'The password must contain a special character, an uppercase letter and a number')
    .required('Field is required'),
  confirmPassword: Yup.string()      
    .matches(/^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[A-Z])(?=.*[0-9]).+$/, 'The password must contain a special character, an uppercase letter and a number')
    .required('Field is required'),
});